import { cn } from "@/dentlab/src/lib/util";
import { FilePreview } from "../../../file-preview/file-preview.component";
import { getFileType } from "@/lib/utils/file-utils";

export const ThumbnailStrip: React.FC<{
    fileIds: string[];
    currentIndex: number;
    onSelectFile: (index: number) => void;
    getCachedFile: (id: string) => any;
}> = ({ fileIds, currentIndex, onSelectFile, getCachedFile }) => (
    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
        <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-thin scrollbar-thumb-white/30 scrollbar-track-transparent">
            {fileIds.map((fileId, index) => {
                const file = getCachedFile(fileId);
                const isActive = index === currentIndex;

                return (
                    <button
                        key={fileId}
                        onClick={() => onSelectFile(index)}
                        className={cn(
                            "relative w-16 h-16 m-[4px] rounded overflow-hidden border-2 transition-all flex-shrink-0",
                            isActive
                                ? "border-white shadow-lg scale-110"
                                : "border-white/50 hover:border-white/80 opacity-70 hover:opacity-100"
                        )}
                        aria-label={`Datei ${index + 1}`}
                    >
                        {file ? (
                            <FilePreview
                                url={file.signed_url}
                                fileType={getFileType(
                                    file.meta_data as Record<string, any> | null,
                                    file.file_name
                                )}
                                fileName={file.file_name || undefined}
                                width={60}
                            />
                        ) : (
                            <div className="w-full h-full bg-gray-600" />
                        )}
                    </button>
                );
            })}
        </div>
    </div>
);